/* eslint-disable no-useless-catch */

import { serialize } from '../utils';
// import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/product-price-policies';

export const ProductPricePolicyApi = {
  find: async (option: any = {}) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: any = {}) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: any = {}) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: any = {}) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeMulti: async (body: { productPricePolicyIDs: string[] }) => {
    const url = `${pathname}/delete/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDataFromGGSheet: async (option: GetProductPricePoliciesFromGGSheet) => {
    let url = `${pathname}/import`;
    option.googleSheetUrl = encodeURIComponent(option.googleSheetUrl);
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDataFromExcel: async (body: {
    rawProducts: RawProductPricePoliciesType[];
    entityPricePolicyID?: string;
    importMethod?: number;
  }) => {
    const options = {
      entityPricePolicyID: body.entityPricePolicyID,
      importMethod: body.importMethod,
    };
    let url = `${pathname}/import/preview-xlsx`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  importDataFromGGSheet: async (
    body: ImportProductPricePoliciesFromGGSheet
  ) => {
    const url = `${pathname}/import`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  importDataFromExcel: async (body: ImportProductPricePoliciesFromExcel) => {
    const url = `${pathname}/import/xlsx`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSheetsFromGGSheet: async (id: string) => {
    const url = `${pathname}/import/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface ImportProductPricePoliciesFromGGSheet {
  entityPricePolicyID?: string;
  googleSheetUrl: string;
  sheetName: string;
  importMethod?: number;
}

export interface RawProductPricePoliciesType {
  code: string;
  name: string;
  categoryName: string;
  standardPriceUnit: string;
  wholesalePrice: string;
  ratio: string;
  price: string;
  priceUnit: string;
}

export interface ImportProductPricePoliciesFromExcel {
  entityPricePolicyID?: string;
  rawProducts: RawProductPricePoliciesType[];
  importMethod: number;
}

export type GetProductPricePoliciesFromGGSheet = Pick<
  ImportProductPricePoliciesFromGGSheet,
  Exclude<keyof ImportProductPricePoliciesFromGGSheet, 'importMethod'>
>;

export type PricePolicyImportRelativeTime = {
  minutes?: number;
  hours?: number;
  date?: number;
  dayOfWeek?: number;
  absoluteTime?: string;
};

export interface PricePolicyImportSettings {
  googleSheetUrl: string;
  sheetName: string;
  range?: string;
  type?: number;
  time?: PricePolicyImportRelativeTime;
  isAutoImportEnabled?: boolean;
  updatedAt: string;
  importedAt?: string;
  status?: number;
}
